"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApiErrorType = void 0;
var UserApiErrorType;
(function (UserApiErrorType) {
    UserApiErrorType["PARTNER_OR_MEMBERSHIP_NOT_FOUND"] = "universcoop.users.partnerOrMembershipNotFound";
    UserApiErrorType["AUTH0_USER_NOT_FOUND"] = "universcoop.users.auth0UserNotFound";
})(UserApiErrorType || (exports.UserApiErrorType = UserApiErrorType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlcnMuZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3VzZXJzLmVycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLGdCQUdYO0FBSEQsV0FBWSxnQkFBZ0I7SUFDMUIscUdBQWlGLENBQUE7SUFDakYsZ0ZBQTRELENBQUE7QUFDOUQsQ0FBQyxFQUhXLGdCQUFnQixnQ0FBaEIsZ0JBQWdCLFFBRzNCIn0=